import React, {useState, useEffect, useRef} from 'react';
import "../../../css/share.scss";
import Cookies from 'js-cookie';
import APICall from '../../actions/apicall';
import mailIcon from '../../../images/appIcons/mailIcon.png';
import facebookIcon from '../../../images/appIcons/facebookIcon.png';
import blueLink from '../../../images/appIcons/blueLink.png';
import linkedInIcon from '../../../images/appIcons/linkedInIcon.png';
import twitterIcon from '../../../images/appIcons/twitterIcon.png';
import whatsappIcon from '../../../images/appIcons/whatsappIcon.png';

function Share(props) {
    const [whatsApp, setWhatsApp] = useState('');
    const [linkedIn, setLinkedIn] = useState('');
    const [mail, setMail] = useState('');
    const [facebook, setFacebook] = useState('');
    const [twitter, setTwitter] = useState('');
    
    const businessName = props.businessData.business_name ? props.businessData.business_name : props.businessData.fields.business_name;
    const businessCity = props.businessData.location_address_city ? props.businessData.location_address_city : props.businessData.fields.location_address_city;


    let accessToken = Cookies.get('access_token') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;

    useEffect(() => {
        if (props.url) {
            setWhatsApp(`https://web.whatsapp.com/send?text=Click+here+to+view+RS11's+FREE+estimated+value+of+${businessName}+business+in+${businessCity}+and+estimated+value+of+millions+of+more+businesses+in+the+US.%0A${props.url}`);
            setLinkedIn(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(props.url)}&summary=${encodeURIComponent(`Click here to view RS11’s FREE estimated value of ${businessName} business in ${businessCity} and estimated value of millions of more businesses in the US.`)}`);
            setMail(`mailto:?subject=RS11&body=Click here to view RS11’s FREE estimated value of ${businessName} business in ${businessCity} and estimated value of millions of more businesses in the US.%0A${props.url}`);
            setFacebook(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(props.url)}`);
            setTwitter(`https://twitter.com/intent/tweet?url=${props.url}&text=Click here to view RS11’s FREE estimated value of ${businessName} business in ${businessCity} and estimated value of millions of more businesses in the US.%0A`);
        }
    }, [props.url]);
    
    const handleShare = (options) => {
        window.dataLayer.push({'event': 'share', 'method': options, 'businessId': props.businessData.id});
        if (options == 'copy_link') {
            navigator.clipboard.writeText(props.url);
            props.closeShare(options);
        }
        let data = {
            business_id: props.businessData.id,
            shared_from: options
        }
        props.closeShare(options);
        APICall.BusinessShare(data, accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
            }
        })
    }

    return(
        <div>
            <div className={props.likedBusiness ? "media-icons-like" : "media-iconss"} style={accessToken == null ? {'top': '25%'} : {'top': '27%'}}>
                <a href={whatsApp} target="_blank" onClick={() => handleShare('whatsapp')}><img className='icon-class' src={whatsappIcon} /></a>
                <a href={linkedIn} target="_blank" onClick={() => handleShare('linkedin')}><img className='icon-class' src={linkedInIcon} /></a>
                <a href={mail} target="_blank" onClick={() => handleShare('mail')}><img className='icon-class' src={mailIcon} /></a>
                <a href={facebook} target="_blank" onClick={() => handleShare('facebook')}><img className='icon-class' src={facebookIcon} /></a>
                <a href={twitter} target="_blank" onClick={() => handleShare('twitter')}><img className='icon-class' src={twitterIcon} /></a>
                <a onClick={() => handleShare('copy_link')}><img className='icon-class' src={blueLink} /></a>
            </div>
        </div>
    )
}

export default Share;
